import { inject, Injectable } from '@angular/core';

import { CommonAPIService } from './common.service';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TeamHierarchyService {

    private commonService = inject(CommonAPIService);

    teamList: Subject<string> = new BehaviorSubject<string>('');
    teamModalType: number;
    teamData: any;

    constructor() { }

    addTeamHierarchy(params) {
        return this.commonService.post('/team_hierarchy/add_update', params);
    }

    listTeamHierarchy(payload) {
        return this.commonService.post('/team_hierarchy/list', payload);
    }

    changeAlertScheduleStatus(payload) {
        return this.commonService.post('/team_hierarchy/change-alert-schedule-status', payload);
    }

    deleteTeamHierarchy(id: string) {
        return this.commonService.delete('/team_hierarchy/' + id);
    }


    getCoverageProfiles() {
        return this.commonService.get('/coverage-profiles');
    }


    getCoverAssignments() {
        return this.commonService.get('/cover-assignments');
    }

    createCoverageProfile(payload: {
        team: string; name: string; start_time: string; end_time: string;
    }) {
        return this.commonService.post('/coverage-profiles', payload);
    }


    updateCoverageProfile(id: string, payload: {
        team: string; name: string; start_time: string; end_time: string;
    }) {
        return this.commonService.put(`/coverage-profiles/${id}`, payload);
    }

    deleteCoverageProfile(id: string) {
        return this.commonService.delete(`/coverage-profiles/${id}`);
    }

    getShiftRoster(teamId: string, weekStart?: string, shiftId?: string) {
        const params: string[] = [];
        if (weekStart) params.push(`week_start=${weekStart}`);
        if (shiftId) params.push(`shiftId=${encodeURIComponent(shiftId)}`);
        const query = params.length ? `?${params.join('&')}` : '';
        return this.commonService.get(`/team_hierarchy/${teamId}/shift-roster${query}`);
    }


    assignRosterCell(teamId: string, payload: {
        date: string; shiftId: string; user: string; start_time: string; end_time: string;
        planId?: string;
    }) {
        return this.commonService.post(`/team_hierarchy/${teamId}/shift-roster/assign`, payload);
    }

    assignRosterCellsBulk(teamId: string, assignments: {
        date: string; shiftId: string; user: string; start_time: string; end_time: string;
    }[]) {
        return this.commonService.post(
            `/team_hierarchy/${teamId}/shift-roster/assign-bulk`, { assignments }
        );
    }

    clearRosterCell(teamId: string, payload: { date: string; shiftId: string; planId?: string }) {
        return this.commonService.post(`/team_hierarchy/${teamId}/shift-roster/clear`, payload);
    }

    resetRosterWeek(teamId: string, weekStart: string) {
        return this.commonService.post(`/team_hierarchy/${teamId}/shift-roster/reset-week`, {
            week_start: weekStart
        });
    }

}

